import AxiosContext from "../contexts/GeminiAxiosContext";

export const GeminiService = {
    classes: async () => {
        try {
            const { data, status } = await AxiosContext.get(`/api/marks/classes`);
            return { data: data, status: status }
        } catch (error) {
            return { data: null, error: error }
        }
    },
    analytics: async (prompt: string) => {
        try {
            const { data, status } = await AxiosContext.post(`/api/marks`, { prompt: prompt });
            return { data: data, status: status }
        } catch (error) {
            return { data: null, error: error }
        }
    },
}